// extracted by mini-css-extract-plugin
export default {"booking_card":"BookingCard_booking_card__J1tfu"};